import {
  FETCH_MASTER_DATA_REQUEST,
  FETCH_MASTER_DATA_SUCCESS,
  FETCH_MASTER_DATA_FAILURE,
} from "./types";

const initialState = {
  loading: false,
  error: null,
  loaded: false,
  branchList: [],
  gradeList: [],
  locationList: [],
  designationList: [],
  departmentList: [],
  divisionList: [],
  categoryList: [],
  projectList: [],
  costCenterList: [],
};

const masterDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MASTER_DATA_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_MASTER_DATA_SUCCESS:
      return { ...state, ...action.payload, loading: false, loaded: true };
    case FETCH_MASTER_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default masterDataReducer;
